<template>
  <v-container>
    <div
      class="mt-5"
      :class="{'mx-10': $vuetify.breakpoint.lgAndUp}"
      style="border:1px solid black"
    >
      <v-tabs
        ref="tabs"
        v-model="active"
        align-with-title
        slider-color="white"
        show-arrows
      >
        <v-tab
          v-for="item in filteredTabItems"
          :key="item.name"
          class="divider font-black"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="active">
        <v-tab-item
          v-if="$hasPermissionTo(['view claim types'])"
          class="pb-12"
        >
          <setup-claims-claim-type-container-view 
            @updated="refreshClaimEntitlementSettings();refreshPolicies();refreshEntitlements()"
          />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view claim entitlement settings'])"
          class="pb-12"
        >
          <setup-claims-claim-entitlement-setting-container-view 
            ref="setting"
            @loaded="setSettingLoaded()"
            @updated="refreshPolicies()"
          />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view claim policies'])"
          class="pb-12"
        >
          <setup-claims-claim-policy-container-view 
            ref="policy"
            @loaded="setPolicyLoaded()"
          />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view claim entitlements'])"
          class="pb-12"
        >
          <setup-claims-claim-entitlement-container-view 
            ref="entitlement"
            @loaded="setEntitlementLoaded()"
          />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view claim transaction date validity rules'])"
          class="pb-12"
        >
          <setup-claims-claim-transaction-date-validity-rule-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view claim approval workflows'])"
          class="pb-12"
        >
          <setup-claims-approval-workflow-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view backup approvers'])"
          class="pb-12"
        >
          <setup-claims-backup-approver-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view claim cycles'])"
          class="pb-12"
        >
          <setup-claims-claim-cycle-container-view />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupClaimsClaimTypeContainerView: () => import('@/components/hris/setup/claims/claim-type/ContainerView'),
      SetupClaimsClaimEntitlementContainerView: () => import('@/components/hris/setup/claims/claim-entitlement/ContainerView'),
      SetupClaimsClaimEntitlementSettingContainerView: () => import('@/components/hris/setup/claims/claim-entitlement-setting/ContainerView'),
      SetupClaimsClaimPolicyContainerView: () => import('@/components/hris/setup/claims/claim-policy/ContainerView'),
      SetupClaimsClaimTransactionDateValidityRuleContainerView: () => import('@/components/hris/setup/claims/claim-transaction-date-validity-rule/ContainerView'),
      SetupClaimsApprovalWorkflowContainerView: () => import('@/components/hris/setup/claims/approval-workflow/ContainerView'),
      SetupClaimsBackupApproverContainerView: () => import('@/components/hris/setup/claims/backup-approver/ContainerView'),
      SetupClaimsClaimCycleContainerView: () => import('@/components/hris/setup/claims/claim-cycle/ContainerView'),
    },
    data () {
      return {
        tabItems: [ ],
        active: null,
        policiesLoaded: false,
        entitlementsLoaded: false,
        claimEntitlementSettingsLoaded: false,
      }
    },

    computed: {   
      filteredTabItems () {
        let modifiedTab = [...this.tabItems]
 
        if (this.$hasPermissionTo(['view claim types'])) {
          modifiedTab.push({ name: 'Claim Types' })
        }

        if (this.$hasPermissionTo(['view claim entitlement settings'])) {
          modifiedTab.push({ name: 'Claim Entitlement Settings' })
        }

        if (this.$hasPermissionTo(['view claim policies'])) {
          modifiedTab.push({ name: 'Claim Policies' })
        }

        if (this.$hasPermissionTo(['view claim entitlements'])) {
          modifiedTab.push({ name: 'Claim Entitlements' })
        }
 
        if (this.$hasPermissionTo(['view claim transaction date validity rules'])) {
          modifiedTab.push({ name: 'Transaction Date Rules' })
        }
 
        if (this.$hasPermissionTo(['view claim approval workflows'])) {
          modifiedTab.push({ name: 'Approval Workflows' })
        }
 
        if (this.$hasPermissionTo(['view backup approvers'])) {
          modifiedTab.push({ name: 'Backup Approvers' })
        }
 
        if (this.$hasPermissionTo(['view claim cycles'])) {
          modifiedTab.push({ name: 'Claim Cycles' })
        }

        return modifiedTab
      },
    },
    methods: {
      setSettingLoaded () {
        this.claimEntitlementSettingsLoaded = true
      },
      setPolicyLoaded () {
        this.policiesLoaded = true
      },
      setEntitlementLoaded () {
        this.entitlementsLoaded = true
      },
      refreshClaimEntitlementSettings () {
        if (this.claimEntitlementSettingsLoaded && this.$hasPermissionTo(['view claim entitlement settings'])) {
          this.$refs.setting.loadData()
        }
      },
      refreshPolicies () {
        if (this.policiesLoaded && this.$hasPermissionTo(['view claim policies'])) {
          this.$refs.policy.loadData()
        }
      },
      refreshEntitlements () {
        if (this.entitlementsLoaded && this.$hasPermissionTo(['view claim entitlements'])) {
          this.$refs.entitlement.loadData()
        }
      },
    },
  }
</script>

<style scoped>
.divider { 
  border-right: 1px solid #707070;
  border-bottom: 1px solid #707070;
} 

.font-black{
  color:black !important;
}

.divider.font-black.v-tab.v-tab--active{
  border-bottom:0px;
}

.v-tab {
  text-transform: none !important;
  max-height: 33px;
}
</style>
